/* ProfileTabs.module.css — shared styles for the platform profile tabs */

.tab {
  display: flex;
  flex-direction: column;
  gap: var(--space-10, var(--space-8));
  padding-bottom: var(--space-10, var(--space-8));
}

/* Empty / loading state */
.placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: 320px;
  border: 1px dashed var(--border-subtle);
  border-radius: var(--radius-lg);
  background: var(--bg-card);
}

.placeholderLabel {
  font-size: var(--text-lg);
  font-weight: var(--weight-semi);
  color: var(--text-secondary);
}

/* Two sections side by side ≥1200px, stacked below */
.twoCol {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-6);
  align-items: start;
}

@media (max-width: 1199px) {
  .twoCol {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ── Subscribers: region tiles ── */

.regionTiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--space-4);
}

@media (max-width: 1100px) {
  .regionTiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .regionTiles {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ── Catalog Insights ── */

.tileRow {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-4);
}

@media (max-width: 900px) {
  .tileRow {
    grid-template-columns: minmax(0, 1fr);
  }
}

.titleTable {
  transition: opacity var(--duration-fast) var(--ease-default);
}

/* Previous results while a filter or sort change loads */
.titleTable[data-stale] {
  opacity: 0.5;
}

.rank {
  font-size: var(--text-base);
  font-weight: var(--weight-semi);
  font-variant-numeric: tabular-nums;
  color: var(--text-muted);
}

.noValue {
  color: var(--text-disabled);
}

.exclusiveRows {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding: var(--space-5);
}

.sentence {
  margin: 0 0 var(--space-2);
  font-size: var(--text-md);
  color: var(--text-secondary);
}

.sentence strong {
  font-weight: var(--weight-semi);
  color: var(--text-primary);
}

.trend {
  padding: var(--space-4) var(--space-5);
  border-top: 1px solid var(--border-subtle);
}
